<template>
  <v-container>
    <v-card-title class="text--center"> </v-card-title>
    <v-card>
      <v-card-title>
        Gestion d'appels d'offres
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          @keyup.enter="filterKey"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-skeleton-loader :loading="loading && !options.page" type="table">
        <v-data-table
          :loading="loading"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          loading-text="Veuillez patienter quelques instants "
          :search="search"
          @page-count="pageCount = $event"
          :options.sync="options"
          :server-items-length="totalDocuments"
          :headers="headers"
          :items="dataValues"
          hide-default-footer
          class="elevation-0"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-dialog v-model="dialogs" max-width="500px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    color="primary"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-sheet elevation="12" class="pa-12">
                  <v-form
                    class="input--fields__wrapper"
                    ref="create"
                    lazy-validation
                    v-on:submit.prevent="onCreate"
                  >
                    <div class="input--fields__container">
                      <v-text-field
                        :rules="[rules.required]"
                        label="N° appel d'offres"
                        v-model="callOfferNumber"
                      ></v-text-field>

                      <v-select
                        :rules="[rules.required]"
                        :items="items"
                        v-model="callStatus"
                        label="État"
                      ></v-select>
                    </div>

                    <div class="input--fields__container">
                      <v-text-field
                        :rules="[rules.required]"
                        label="Date d'ouverture des plis"
                        v-model="OpenDate"
                      ></v-text-field>

                      <v-text-field
                        :rules="[rules.required]"
                        label="Estimation en Dhs Ttc"
                        v-model="EstimationPrice"
                      ></v-text-field>
                    </div>

                    <v-text-field
                      :rules="[rules.required]"
                      label="Frais dossier en dhs"
                      v-model="fileFees"
                    ></v-text-field>

                    <div class="input--fields__container">
                      <v-text-field
                        :rules="[rules.required]"
                        label="Date visite des lieux"
                        v-model="visiteDate"
                      ></v-text-field>
                      <v-text-field
                        :rules="[rules.required]"
                        label="Cautionnement provisoire en Dhs"
                        v-model="callProvisionary"
                      ></v-text-field>
                    </div>

                    <v-file-input
                      :rules="[rules.required]"
                      id="fUpload"
                      accept="application/pdf"
                      v-model="files"
                      placeholder="Upload"
                      label="Pièces jointes"
                      prepend-icon="mdi-paperclip"
                    >
                      <template v-slot:selection="{ text, item, selected }">
                        <v-chip
                          :rules="[rules.required]"
                          :input-value="selected"
                          close
                          @click:close="remove(item)"
                          small
                          label
                          color="primary"
                        >
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>

                    <v-textarea
                      :rules="[rules.required]"
                      @keyup.enter="cardStrokes"
                      v-model="callOfferDescription"
                      label="Objet appel d'offres"
                      prepend-icon="mdi-comment-text-outline"
                    ></v-textarea>
                  </v-form>
                </v-sheet>
                <v-btn color="primary" @click="onCreate" tile>Créer</v-btn>
                <v-overlay :value="overlay">
                  <v-progress-circular
                    indeterminate
                    size="64"
                  ></v-progress-circular>
                </v-overlay>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.callStatus="{ item }">
            <v-chip :color="getColor(item.callStatus)" dark>
              {{ item.callStatus }}</v-chip
            >
          </template>
          <template v-slot:item.callOfferFile="{ item }">
            <v-btn
              @click="url(item)"
              class="text-capitalize"
              color="primary"
              rounded
            >
              Document PDF
            </v-btn>
          </template>
          <template v-slot:item.details="{ item }">
            <v-icon medium class="ml-2" @click="popUpDialog(item)">
              mdi-arrow-up
            </v-icon>
          </template>
          <template v-slot:item.delete="{ item }">
            <v-icon medium class="ml-5" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-skeleton-loader>

      <div class="class text-center pt-2">
        <v-pagination
          circle
          :total-visible="7"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </div>
    </v-card>

    <v-dialog v-model="dialog" width="500" content-class="round">
      <v-sheet elevation="12" class="pa-12">
        <v-form
          class="input--fields__wrapper"
          ref="update"
          lazy-validation
          v-on:submit.prevent="onUpdate"
        >
          <div class="input--fields__container">
            <v-text-field
              :rules="[rules.required]"
              label="N° appel d'offres"
              v-model="editedItem.callOfferNumber"
            ></v-text-field>

            <v-select
              :rules="[rules.required]"
              :items="items"
              v-model="editedItem.callStatus"
              label="État"
            ></v-select>
          </div>

          <div class="input--fields__container">
            <v-text-field
              :rules="[rules.required]"
              label="Date d'ouverture des plis"
              v-model="editedItem.OpenDate"
            ></v-text-field>

            <v-text-field
              :rules="[rules.required]"
              label="Estimation en DHS TTC"
              v-model="editedItem.EstimationPrice"
            ></v-text-field>
          </div>

          <v-text-field
            :rules="[rules.required]"
            label="Frais dossier en dhs"
            v-model="editedItem.fileFees"
          ></v-text-field>

          <div class="input--fields__container">
            <v-text-field
              :rules="[rules.required]"
              label="Date visite des lieux"
              v-model="editedItem.visiteDate"
            ></v-text-field>
            <v-text-field
              :rules="[rules.required]"
              label="Cautionnement provisoire en Dhs"
              v-model="editedItem.callProvisionary"
            ></v-text-field>
          </div>

          <v-text-field
            :rules="[rules.required]"
            label="Attribué a"
            v-model="editedItem.givenTo"
          ></v-text-field>

          <v-file-input
            id="fUpload"
            accept="application/pdf"
            v-model="files"
            placeholder="Upload"
            label="Pièces jointes"
            prepend-icon="mdi-paperclip"
          >
            <template v-slot:selection="{ text, item, selected }">
              <v-chip
                :rules="[rules.required]"
                :input-value="selected"
                close
                @click:close="remove(item)"
                small
                label
                color="primary"
              >
                {{ text }}
              </v-chip>
            </template>
          </v-file-input>

          <v-textarea
            :rules="[rules.required]"
            @keyup.enter="cardStrokes"
            v-model="editedItem.callOfferDescription"
            label="Objet appel d'offres"
            prepend-icon="mdi-comment-text-outline"
          ></v-textarea>
        </v-form>
      </v-sheet>

      <v-btn color="primary" @click="onUpdate" tile>Modifier</v-btn>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: `Drawer`,
  components: {},

  methods: {
    resetCreate() {
      this.$refs.create.reset();
    },
    resetUpdate() {
      this.$refs.update.reset();
    },
    checkRendering() {
      this.$store.state.sdrawer.toRender = true;
    },
    popUpDialog(item) {
      this.editedIndex = this.dataValues.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    getColor(status) {
      if (status === 'Attribué') return 'green';
      else if (status === 'En cours') return 'yellow darken-3';
      else if (status === 'Infructueux') return 'red';
      else if (status === 'Annulé') return 'red';
      else if (status === 'Publié') return 'blue';
    },
    url(item) {
      window.open(`${item.callOfferFile.fileLocation}`);
    },
    ApiCall() {
      this.loading = true;
      const { page } = this.options;
      this.$store.dispatch('appels/CallOffer', page).then((resp) => {
        this.loading = false;

        this.dataValues = resp.data.alloffers;
        this.totalDocuments = resp.data.totalNumber;
        this.itemsPerPage = resp.data.limit;
      });
    },
    FilterApiCall() {
      this.loading = true;
      const { page } = this.options;
      this.$store
        .dispatch('appels/searchCallOffer', {
          page: page,
          searchData: this.search,
        })
        .then((resp) => {
          this.loading = false;

          this.dataValues = resp.data.alloffers;
          this.totalDocuments = resp.data.totalNumber;
        });
    },

    filterKey(event) {
      if (event.keyCode === 13) {
        this.FilterSort();
      }
    },

    extension_checker(tag) {
      const file = document.querySelector(tag);

      for (let index = 0; index < file.files.length; index++) {
        if (/\.(pdf|)$/i.test(file.files[index].name) === false) {
          //change the alert with a function that throws a snackbar or smtng
          alert('only pdf extensions ar supported');
          return false;
        } else {
          return true;
        }
      }
    },

    deleteItem(item) {
      confirm('Are you sure you want to delete this item?') &&
        this.$store
          .dispatch('appels/deleteCallOffer', { _id: item._id })
          .then((resp) => {
            this.ApiCall();
          });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.dataValues[this.editedIndex], this.editedItem);
      } else {
        this.dataValues.push(this.editedItem);
      }
      this.close();
    },

    onUpdate() {
      if (this.$refs.update.validate()) {
        let formData = new FormData();

        if (this.files !== null && this.files !== undefined) {
          formData.append('files', this.files, this.files.name);
        }

        // initial values for other inputs
        formData.append('_id', this.editedItem._id);
        formData.append('callStatus', this.editedItem.callStatus);
        formData.append('callOfferNumber', this.editedItem.callOfferNumber);
        formData.append(
          'callOfferDescription',
          this.editedItem.callOfferDescription
        );
        formData.append('OpenDate', this.editedItem.OpenDate);
        formData.append('EstimationPrice', this.editedItem.EstimationPrice);
        formData.append('callProvisionary', this.editedItem.callProvisionary);
        formData.append('visiteDate', this.editedItem.visiteDate);
        formData.append('fileFees', this.editedItem.fileFees);
        formData.append('givenTo', this.editedItem.givenTo);

        axios({
          url: '/api/2H32IYOG34U2GH34UYG4/updateCallOffer',
          method: 'POST',
          data: formData,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        })
          .then((response) => {
            this.ApiCall();
            this.resetUpdate();

            this.dialog = false;
          })
          .catch((error) => {});
      }
    },

    onCreate() {
      if (this.$refs.create.validate()) {
        let formData = new FormData();

        if (this.files !== null) {
          formData.append('files', this.files, this.files.name);
        }

        // initial values for other inputs
        formData.append('callStatus', this.callStatus);
        formData.append('callOfferNumber', this.callOfferNumber);
        formData.append('callOfferDescription', this.callOfferDescription);
        formData.append('OpenDate', this.OpenDate);
        formData.append('EstimationPrice', this.EstimationPrice);
        formData.append('callProvisionary', this.callProvisionary);
        formData.append('visiteDate', this.visiteDate);
        formData.append('fileFees', this.fileFees);

        this.overlay = true;

        axios({
          url: '/api/2H32IYOG34U2GH34UYG4/createCallOffer',
          method: 'POST',
          data: formData,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        })
          .then((response) => {
            this.ApiCall();
            this.resetCreate();
            this.overlay = false;

            this.dialogs = false;
          })
          .catch((error) => {});
      }
    },

    FilterSort() {
      if (this.search !== null) {
        this.FilterApiCall();
      } else {
        return false;
      }
    },
  },
  computed: {
    test() {
      return this.$store.state.appels.obj;
    },
  },

  mounted() {
    this.loading = false;
    this.checkRendering();
  },

  watch: {
    options: {
      handler() {
        if (this.search !== null) {
          this.FilterApiCall();
        } else {
          this.ApiCall();
        }
      },
      deep: true,
    },
  },

  data: () => ({
    overlay: false,

    search: null,

    rules: {
      required: (value) => !!value || 'Ce champ est obligatoire.',
      min: (v) =>
        v.length >= 8 || 'Le champ doit contenir 8 caractères minimum',
      emailRules: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Veuillez entrer une adresse électronique valide',
    },

    _id: '',
    callOfferNumber: '',
    callStatus: '',
    callOfferNumber: '',
    callOfferDescription: '',
    EstimationPrice: '',
    depotDate: '',
    fileFees: '',
    visiteDate: '',
    callProvisionary: '',
    OpenDate: '',

    loading: true,

    options: {},
    totalDocuments: 0,
    itemsPerPage: 10,
    page: 1,
    pageCount: 0,
    editedIndex: -1,
    dialog: false,
    defaultItem: {
      _id: '',
      callOfferNumber: '',
      callStatus: '',
      callOfferNumber: '',
      callOfferDescription: '',
      EstimationPrice: '',
      depotDate: '',
      fileFees: '',
      visiteDate: '',
      callProvisionary: '',
      OpenDate: '',
      givenTo: '',
    },
    editedItem: {
      _id: '',
      callOfferNumber: '',
      callStatus: '',
      callOfferNumber: '',
      callOfferDescription: '',
      EstimationPrice: '',
      depotDate: '',
      fileFees: '',
      visiteDate: '',
      callProvisionary: '',
      OpenDate: '',
      givenTo: '',
    },
    headers: [
      { text: "N° appel d'offres", value: 'callOfferNumber' },
      { text: 'Dossier', value: 'callOfferFile' },
      { text: "Date d'ouverture des plis", value: 'OpenDate' },
      { text: 'Détails', value: 'details' },
      { text: 'État', value: 'callStatus' },
      { text: 'Supprimer', value: 'delete', show: true },
    ],
    dataValues: [],
    overlay: false,
    flex: [4, 6, 3],
    show: false,

    items: ['Attribué', 'En cours', 'Infructueux', 'Annulé', 'Publié'],

    // Details update

    files: null,
    detailId: '',
    detailEtat: '',
    detailDateOpening: '',
    detailEstimation: '',
    detailDateEchant: '',
    detailFrais: '',
    detailDateVisite: '',
    detailCautionnement: '',
    detailObjetAppel: '',
  }),
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Karla:ital@1&family=Montserrat&display=swap');

.input--fields__container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}

.class {
  background-color: white;
}

.v-chip {
  width: 100px;
  justify-content: center;
}

/* Dialog Styling */

.round {
  border-radius: 30px;
  overflow-y: hidden;
}

@media only screen and (device-width: 1920px) and (device-height: 1080px) {
  .v-card {
    margin-left: 26px !important;
    width: 91%;
  }
}
</style>
